import { Typography } from 'antd'

export const Title = Typography.Title
export const Text = Typography.Text
